import { render, staticRenderFns } from "./EntesPublicos.vue?vue&type=template&id=28ee5a38"
import script from "./EntesPublicos.vue?vue&type=script&lang=js"
export * from "./EntesPublicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports